export default __webpack_public_path__ + "Roboto-Medium.ttf?7c8d04cd831df3033c8a96a2668d645e";